import React from "react";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import "./AgriStackComponent.css";
import "react-awesome-slider/dist/styles.css";
import TradeStack from "../../images/profit.png";
import WorkOrder from "../../images/work-order.svg";
import Logistic from "../../images/logistics.svg";
import IoB from "../../images/IoB.svg";
import { NavLink } from "react-router-dom";
import { Typography } from "@material-ui/core";

const stackData = [
  { title: "TradeHub Stack", image: TradeStack, path: "/trade-hub-stack" },

  { title: "Work Order Stack", image: WorkOrder, path: "/work-order-stack" },
  { title: "Logistic Stack", image: Logistic, path: "/logistic-stack" },

  { title: "Beckn Stack", image: IoB, path: "/ComingSoon" },
];

// AgriCommerceStack Component 

const AgriCommerceStack = () => {
  return (
    <div
      maxwidth={12}
      className="businessPartnerContainer explore-app-background"
    >
      {/* Container for Grid Layout */}
      <Container maxWidth="sm" className="gridSection gridSection--mod ">
        <Grid
          container={true}
          alignItems="center"
          spacing={1}
          direction="row"
          justifyContent="space-between"
        >
          {/* Mapping through stackData to render each stack item */}
          {stackData.map(({ title, image, path }, index) => {
            return (
              <Grid
                item
                md={2}
                sm={4}
                xs={6}
                key={index}
                className="stack-data-container"
              >
                {/* Navigation Link for each stack item */}
                <NavLink to={path}>
                  <img src={image} alt={title} />
                  <Typography variant="h4" align="center">
                    {title}
                  </Typography>
                </NavLink>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
};


export default AgriCommerceStack;
